const ProductShowcase = () => {
  return (
    <section id="stability-botanical-collection" className="relative overflow-hidden">
      {/* Mobile: stacked layout, Desktop: side by side */}
      <div className="flex flex-col md:flex-row md:min-h-[520px] md:items-stretch">

        {/* Image */}
        <div
          className="w-full h-64 sm:h-80 md:w-1/2 md:h-auto md:min-h-[520px] relative"
          style={{
            backgroundImage: 'url(https://static.readdy.ai/image/296ab9838c8a2f1e2b2bac03a156c5b2/9fd80537f0fe141f91586fa08cc5b4d9.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="absolute inset-0 bg-charcoal/10"></div>
        </div>

        {/* Content */}
        <div className="w-full md:w-1/2 flex items-center justify-center px-6 py-10 sm:px-10 sm:py-12 md:px-16 md:py-20 bg-warmWhite">
          <div className="max-w-md w-full">
            {/* Label */}
            <div className="flex items-center gap-3 mb-6 md:mb-8">
              <div className="w-8 h-[1px] bg-bronze/50"></div>
              <span className="text-bronze text-[9px] font-sans font-semibold tracking-[0.3em] uppercase">
                Coming Soon
              </span>
            </div>

            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-light text-charcoal italic mb-6 md:mb-8 leading-snug">
              Stability Botanical Collection
            </h2>

            <div className="space-y-4">
              <p className="text-textGray text-sm sm:text-[13px] font-sans font-light leading-relaxed">
                Inspired by recurring clinical patterns observed through the Vionne Stability Method, the Stability Botanical Collection is currently in development.
              </p>
              <p className="text-textGray text-sm sm:text-[13px] font-sans font-light leading-relaxed">
                This forthcoming line will feature carefully formulated botanical preparations designed to support nervous system balance, hormonal rhythm, circulation, and skin vitality.
              </p>
              <p className="text-textGray text-sm sm:text-[13px] font-sans font-light leading-relaxed italic border-l-2 border-bronze/30 pl-4 mt-6">
                More details will be introduced as the collection evolves.
              </p>
            </div>

            {/* Decorative line */}
            <div className="mt-8 md:mt-10 flex items-center gap-4">
              <div className="w-12 h-[1px] bg-bronze/40"></div>
              <div className="w-1.5 h-1.5 rounded-full bg-bronze/40"></div>
              <div className="w-6 h-[1px] bg-bronze/40"></div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default ProductShowcase;
